























import { Vue, Prop, Component } from 'vue-property-decorator';
import CondensedProductList from '@/project/product/condensed/CondensedProductList.vue';
import Tabs from '@/core/ui-components/tabs/Tabs.vue';
import Tab from '@/core/ui-components/tabs/Tab.vue';
import loggingService from '@/core/logging.service';
import { ProductDetailsPageViewModel, ProductRecommendationsBlockViewModel } from '@/types/contentServerContract';
import { ProductRecommendationType, ProductTileViewObject } from '@/types/apiServerContract';
import Api from '@/project/http/Api.service';
import GTMService from '@/project/tracking/gtm/GTM.service';

interface RecommendationsResult {
    content: ProductRecommendationsBlockViewModel,
    products: ProductTileViewObject[]
}

@Component({
    components: { Tabs, Tab, CondensedProductList }
})
export default class ProductDetailsRecommendations extends Vue {
    @Prop({ required: true, type: String })
    productId!: string;

    @Prop()
    productDetailsPage!: ProductDetailsPageViewModel;

    recommendationsResult: RecommendationsResult[] = [];
    loaded: boolean = false;

    changed(relationsType: string) {
        GTMService.trackProductDetailsTabChange(relationsType);
    }

    async getRecommendationsContent() {
        try {
            const result = this.productDetailsPage;
            const recommendationsBlockContent = result.recommendations.map(x => x.content as ProductRecommendationsBlockViewModel);
            const recommendationsProductDataPromises = recommendationsBlockContent.map(x => this.getProductData(x));

            await Promise.all(recommendationsProductDataPromises);

            this.recommendationsResult.sort((a, b) => {
                const indexA = recommendationsBlockContent.indexOf(a.content);
                const indexB = recommendationsBlockContent.indexOf(b.content);
                return indexA - indexB;
            });
        } catch (e) {
            // No content - ignored
        } finally {
            this.loaded = true;
        }
    }

    async getProductData(content: ProductRecommendationsBlockViewModel): Promise<void> {
        try {
            const result = await Api.recommendations.recommend({
                categoryIdFilterPositiveList: content.categoryIdFilterPositiveList,
                categoryIdFilterNegativeList: content.categoryIdFilterNegativeList,
                displayedAtLocation: content.displayLocation,
                intervalDays: content.interval,
                popularityType: content.popularity,
                categoryId: content.categoryId,
                productId: this.productId,
                productCount: content.productCount,
                recommendationType: content.type,
                allowFillIfNecessary: content.allowFillIfNecessary,
                brandId: content.brandId,
                hasImages: content.hasImages,
                stockFilter: content.stockFilter,
                showFeedProducts: content.showFeedProducts
            });

            if (result?.products?.length > 0) {
                this.recommendationsResult.push({
                    content: content,
                    products: result.products
                });
            }
        } catch (e) {
            loggingService.error(e);
        }
    }

    trackingListName(recommendation: ProductRecommendationsBlockViewModel):string {
        const key = Object.keys(ProductRecommendationType).filter((v) => isNaN(Number(v))).find(k => ProductRecommendationType[k] === recommendation.type) || 'recommendation';
        // format: recommendation/relation - page type - recommendation type
        return `recommendations-${this.$route.name}-${key}`;
    }

    created() {
        this.getRecommendationsContent();
    }
}
